import React, { ReactNode } from 'react';
import { Button } from 'antd';
import { getErrorType } from './errorTypes';
import { getErrorConfig } from './errorConfig';

export interface ErrorAction {
  text: string;
  onClick: () => void;
}

export interface ErrorFallbackProps {
  error: Error | null;
  resetErrorBoundary: () => void;
  title?: ReactNode;
  description?: ReactNode;
  primaryAction?: Partial<ErrorAction>;
  secondaryAction?: ErrorAction;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
  title,
  description,
  primaryAction,
  secondaryAction,
}) => {
  const errorType = getErrorType(error);
  const defaultConfig = getErrorConfig(errorType, error);

  // 合并默认配置和自定义配置
  const finalPrimaryAction = {
    ...defaultConfig.primaryAction,
    ...primaryAction,
    onClick: primaryAction?.onClick || resetErrorBoundary,
  };

  const finalSecondaryAction = secondaryAction || defaultConfig.secondaryAction;

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-red-50 mb-4">
        {defaultConfig.icon}
      </div>

      <h1 className="text-lg font-semibold text-gray-900 mb-2">
        {title || defaultConfig.title}
      </h1>

      <p className="text-sm text-gray-500 mb-6">
        {description || defaultConfig.description}
      </p>

      <div className="flex gap-2">
        {finalSecondaryAction && (
          <Button onClick={finalSecondaryAction.onClick} className="w-full">
            {finalSecondaryAction.text}
          </Button>
        )}
        <Button
          type="primary"
          onClick={finalPrimaryAction.onClick}
          className="w-full"
        >
          {finalPrimaryAction.text}
        </Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
